import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoSpacesPipe } from './noSpaces.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [NoSpacesPipe],
  exports: [NoSpacesPipe],
})
export class NoSpacesPipeModule {}
